import { sentryClient, sentryKey, sentryProject, version, agentPath, env, allowCookies } from 'utils/settings';

const sentryEnabled =
    window.ikea && window.ikea.sentry && sentryKey && sentryProject && sentryClient && version && allowCookies;

if (sentryEnabled) {
    const regex = new RegExp(agentPath, '');
    window.ikea.sentry.register(
        sentryProject,
        sentryKey,
        sentryClient,
        version,
        1, // Log 100% of errors for now
        [regex]
    );
} else {
    console.warn('[favs-agent] Sentry is not active');
}

export const reportError = (e: Error | string) => {
    if (sentryEnabled) {
        window.ikea.sentry.store(e, sentryProject, sentryKey, sentryClient, version, 1);
    }
    if (env !== 'production') {
        console.error(e);
    }
};
